import { Inject, Injectable, signal } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { TrpcAPIService } from '../trpc-api.service';
import { interval, merge, ReplaySubject, timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '@server/src';


type RouterOutput = inferRouterOutputs<AppRouter>;
type EditLock = RouterOutput["editLock"]["getAndTouchLockInfo"];

@Injectable({
  providedIn: null
})
export class EditLockService {

  constructor(public auth: AuthService,@Inject('ServerApi') private trpc: TrpcAPIService) {
    this.timerObs.subscribe(async () => {
      this.refreshLock();
    });
  }

  private async refreshLock() {
    let klantNo = this.klantNo();
    if (klantNo != undefined) {
      let li = await this.trpc.client.editLock.getAndTouchLockInfo.query(klantNo);
      this.lockInfo.set(li);
      this.trpc.hasLock.update((v) => li.hasLock);
    }
  }

  public klantNo = signal<string | undefined>(undefined);

  private onDemand = new ReplaySubject(1);
  private timerObs = merge(interval(10000).pipe(takeUntilDestroyed()), timer(1000), this.onDemand);
  public lockInfo = signal<EditLock | undefined>(undefined);


  public async lock(initial: boolean) {
    let klantNo = this.klantNo();
    if (klantNo != undefined) {
      if (await this.trpc.checkKlantPermissions(klantNo)) {
        await this.trpc.client.editLock.lock.mutate({
          klantNo: klantNo,
          initial: initial
        });      
        
      }
      this.onDemand.next(1);
    }
  }

  public async unlock() {
    let klantNo = this.klantNo();
    if (klantNo != undefined) {
      await this.trpc.checkKlantPermissions(klantNo);
      await this.trpc.client.editLock.unlock.mutate(klantNo);      
      this.onDemand.next(1);
    }
  }

}
